
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 450 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFCE00","d":"M0 0h450v300H0z"}}),_c('path',{attrs:{"fill":"#289728","d":"M0 0h450v225H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h450v150H0z"}}),_c('path',{attrs:{"fill":"#003082","d":"M0 0h450v75H0z"}}),_c('path',{attrs:{"fill":"#D21034","d":"M187.5 0h75v300h-75z"}}),_c('path',{attrs:{"fill":"#FFCE00","d":"M75.028 7.004L94.9 67.996 42.902 30.333h64.197L55.1 67.996 75.028 7.004z"}})])
          )
        }
      }
    